import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class OrganisationDetailsRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/organisations/:id")
    route (id) {
        System.import("./index").then(View => {
            const view = new View.default({ organisationId: id });

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default OrganisationDetailsRoute;



// WEBPACK FOOTER //
// ./public/domain/views/organisation/organisations.route.js